import React from 'react';
import useUser from '../hooks/useUser';
import ServerModuleMenu from '../masters/server/ModuleMenu';

const ModuleMenu = () => {
    const { userRole } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';

    return <ServerModuleMenu />;
};

export default ModuleMenu;
